import { render, staticRenderFns } from "./CloneTransactionView.vue?vue&type=template&id=c5a010f6"
import script from "./CloneTransactionView.vue?vue&type=script&lang=js"
export * from "./CloneTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports